import type Post from '@/models/post';

/**
 * Destination count for TripCard / frosted overlay.
 * Prefer post_locations count (lists and itineraries), then city arrays, then 1.
 */
export function getTripCardDestinationCount(post: Post): number {
  const fromLocations = post.postLocations?.length ?? 0;
  if (fromLocations > 0) return fromLocations;
  const fromCityIds = post.city_identifying_names?.length ?? 0;
  if (fromCityIds > 0) return fromCityIds;
  const fromCities = post.cities?.length ?? 0;
  if (fromCities > 0) return fromCities;
  return 1;
}
